import { defaultIconProps, IconProps } from './IconProps';

export const IconPoint: React.FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
    <circle cx="12" cy="12" r="4" stroke={color} fill="none" strokeWidth="3" />
  </svg>
);

IconPoint.defaultProps = defaultIconProps;
